module.exports = __webpack_public_path__ + "static/media/bg3.6ab124b0.jpg";